import { inject, Injectable } from '@angular/core';
import { FormService } from '@eview/core/domain/form/form.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import {
  EFormsActions,
  ListForms,
  ListFormsFailure,
  ListFormsSuccess
} from '../actions/forms.actions';
import { selectFormsLoaded } from '../selectors/catalog.selectors';
import { AppState } from '../states/app.state';

@Injectable()
export class FormsEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store<AppState>);
  private readonly formService = inject(FormService);

  list$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ListForms>(EFormsActions.ListForms),
      withLatestFrom(this.store.select(selectFormsLoaded)),
      filter(([action, loaded]) => action.force || !loaded),
      switchMap(() =>
        this.formService.listForms().pipe(
          map(payload =>
            payload ? new ListFormsSuccess(payload) : new ListFormsFailure()
          ),
          catchError(() => of(new ListFormsFailure()))
        )
      )
    )
  );
}
